// 使用方法

// <template>
// <div id="debounced-test">
//   <v-button @click="handelClickByDebounced">防抖</v-button>
//   <v-button @click="handelClickByThrottle" type="success">节流</v-button>
//   <v-button @click="changeStopThrottle(throttle.stop)" type="warning">
//     {{ throttle.stop ? '开启' : '关闭' }}节流
//   </v-button>
//   <v-button @click="destroyThrottle" type="danger">销毁节流函数</v-button>
// </div>
// </template>


// import { Debounced, Throttle } from '@/utils'

// export default class DebouncedTest {
//     private count: number = 1
//     private debouncedUse: Function = new Debounced().use(this.request, this, 1000)


//     private throttle = new Throttle()
//     private throttleUse: Function = this.throttle.use(this.request, this, 1000);

//     private request(params: any) {
//         console.log('this的指向', this);
//         console.log('参数', params);
//         console.log(this.count++)
//     }
//     // 防抖调用
//     private handelClickByDebounced() {
//         this.debouncedUse(123)
//     }
//     // 节流调用
//     private handelClickByThrottle() {
//         this.throttleUse('截流函数')
//     }
//     // 停止 | 开启节流函数
//     private changeStopThrottle(action: boolean) {
//         action ? this.throttle.open() : this.throttle.close()
//     }
//     // 销毁节流函数
//     private destroyThrottle() {
//         this.throttle.destroy()
//     }
// }


/**
 * 防抖(ts)
 * 事件被触发，n秒后执行一次函数，如果n秒内再次被触发，就重新计算时间
 */
export class Debounced {
  /**
   * @param func 需要包装的函数
   * @param context this 指向
   * @param delay 延迟时间，单位ms
   * @param immediate 是否默认执行一次(第一次不延迟)
   */
  public use = (func: any, context: any = null, delay: number = 1000, immediate: boolean = true) => {
    let timer: number | undefined | any;
    return (...args: any) => {
      if (immediate) {
        func.apply(context, args); // 确保引用函数的指向正确，并且函数的参数也不变
        immediate = false;
        return;
      }
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(context, args);
      }, delay);
    };
  }
}


/**
 * 节流(ts)
 * 事件在n秒内连续被触发多次，函数只执行一次。
 */
export class Throttle {
  private timer: number | undefined;
  private stop = false;
  private death = false;

  /**
   * @param func 需要包装的函数
   * @param context this 指向
   * @param delay 延迟时间，单位ms
   * @param immediate 是否默认执行一次(第一次不延迟)
   */
  public use(func: any, context: any = null, delay: number = 1000, immediate: boolean = true): any {
    let flag = true;
    const self: any = this;
    return (...args: any) => {
      if (this.death) {
        func.apply(context, args);
        return;
      }
      if (this.stop) {
        func.apply(context, args);
        return;
      }
      if (immediate) {
        func.apply(context, args);
        immediate = false;
        return;
      }
      if (!flag) {
        return;
      }
      flag = false;
      self.timer = setTimeout(() => {
        func.apply(context, args);
        flag = true;
      }, delay);
    };
  }

  // 销毁
  public destroy(): void {
    this.death = true;
    this.stop = true;
    if (!!this.timer) {
      clearTimeout(this.timer);
      this.timer = undefined;
    }
  }

  // 开启
  public open(): void {
    if (!this.death) {
      this.stop = false;
    }
  }

  // 关闭
  public close(): void {
    this.stop = true;
  }
}
